import { Users, UserCheck, TrendingUp, ClipboardList, CalendarDays, BarChart3 } from 'lucide-react';
import { consultancyFeatures } from '@/mocks/homeData';
import { useNavigate } from 'react-router-dom';

const iconMap: Record<string, React.ReactNode> = {
  Users: <Users className="w-6 h-6 text-navy-500" />,
  UserCheck: <UserCheck className="w-6 h-6 text-navy-500" />,
  TrendingUp: <TrendingUp className="w-6 h-6 text-navy-500" />,
  ClipboardList: <ClipboardList className="w-6 h-6 text-navy-500" />,
  CalendarDays: <CalendarDays className="w-6 h-6 text-navy-500" />,
  BarChart3: <BarChart3 className="w-6 h-6 text-navy-500" />,
};

export default function ForConsultanciesSection() {
  const navigate = useNavigate();

  return (
    <section id="for-consultancies" className="bg-white py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="text-xs font-semibold tracking-widest text-gold-600 uppercase">For Consultancies</span>
            <h2 className="mt-3 text-3xl md:text-4xl lg:text-5xl font-bold text-navy-600">
              The Complete Platform to Grow Your Business
            </h2>
            <p className="mt-4 text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
              Manage your entire consultancy operation in one place — from student enquiries to visa approvals.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {consultancyFeatures.map((feature) => (
              <div
                key={feature.title}
                className="bg-gray-50 rounded-xl p-6 md:p-8 hover:shadow-md transition-all group"
              >
                <div className="w-12 h-12 rounded-lg bg-white shadow-sm flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
                  {iconMap[feature.icon]}
                </div>
                <h3 className="text-lg font-semibold text-navy-600">{feature.title}</h3>
                <p className="mt-2 text-sm text-gray-500 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => navigate('/consultancy/login')}
              className="px-8 py-3.5 bg-navy-600 text-white font-semibold rounded-md hover:bg-navy-700 transition-all whitespace-nowrap cursor-pointer"
            >
              Login to Dashboard
            </button>
            <button
              onClick={() => navigate('/consultancy/register')}
              className="px-8 py-3.5 bg-gold-500 text-navy-700 font-semibold rounded-md hover:bg-gold-400 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              Create Free Account
              <i className="ri-arrow-right-line" />
            </button>
          </div>

          <p className="mt-6 text-center text-sm text-gray-400">
            No credit card required. Free 14-day trial on all plans.
          </p>
        </div>
      </div>
    </section>
  );
}